<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs pt-5>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 lg11>
            <h2>
              <v-icon color="#077893" @click="Fn_BackIndex" size="38"
                >mdi-chevron-left</v-icon
              >{{ $t("smtp.text7") }}
            </h2>
          </v-flex>
        </v-layout>
        <v-layout row wrap justify-center align-center pt-3>
          <v-flex xs11 lg11>
            <v-form ref="formSMTP" v-model="valid">
              <v-card class="rounded-lg">
                <v-card-title primary-title>
                  {{ $t("smtp.text2") }}
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-5">
                  <v-layout row wrap justify-center align-baseline>
                    <v-flex xs11 sm11 md11 lg11 pa-1>
                      <b class="black-text"
                        >รูปแบบการเชื่อมต่อ Mail Server Inet</b
                      >
                    </v-flex>
                    <v-flex xs11 sm11 md11 lg11 pa-1 mt-n3>
                      <v-radio-group v-model="SelectTypeEmail" column>
                        <v-radio
                          color="#077893"
                          label="ใช้ Mail Server ของทาง INET"
                          :value="false"
                        ></v-radio>
                        <v-radio
                          color="#077893"
                          label="ใช้ Mail Server ของทางผู้ใช้งาน"
                          :value="true"
                        ></v-radio>
                      </v-radio-group>
                    </v-flex>
                  </v-layout>
                  <v-layout
                    row
                    wrap
                    justify-center
                    align-baseline
                    v-if="SelectTypeEmail === true"
                  >
                    <v-flex xs11 sm11 md11 lg11 pa-1>
                      <b class="red--text"
                        >*** กรุณาแจ้ง SMTP Host ไปยังผู้ดูแลระบบ CMP
                        เพื่อขอใช้งานก่อนทำการตั้งค่า</b
                      >
                    </v-flex>
                    <v-flex xs11 sm11 md7 lg7 pa-1>
                      <b>SMTP Host</b>
                      <v-text-field
                        outlined
                        dense
                        color="#077893"
                        v-model="SmtpHost"
                        :rules="HostRules"
                        prepend-inner-icon="mdi-cloud-download-outline"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs11 sm11 md4 lg4 pa-1>
                      <b>SMTP Port</b>
                      <v-text-field
                        outlined
                        dense
                        color="#077893"
                        v-model="SmtpPort"
                        :counter="4"
                        :oninput="rulesObject.numRegex"
                        prepend-inner-icon="mdi-dns-outline "
                        :rules="[(v) => !!v || 'กรุณากรอก SMTP Port']"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <!-- <v-layout row wrap justify-center align-start>
                    <v-flex xs11 lg1> Port </v-flex>
                    <v-flex xs11 lg5>
                      <v-text-field
                        outlined
                        dense
                         color="#077893"
                        v-model="SmtpPort"
                        :counter="4"
                        :oninput="rulesObject.numRegex"
                        prepend-inner-icon="mdi-dns-outline "
                        :rules="[(v) => !!v || 'กรุณากรอก Port']"
                      ></v-text-field>
                    </v-flex>
                  </v-layout> -->
                  <v-layout
                    row
                    wrap
                    align-center
                    justify-center
                    v-if="SelectTypeEmail === true"
                  >
                    <v-flex xs11 sm11 md11 lg11>
                      <b>ใช้งาน Username Password</b>
                      <v-radio-group v-model="SmtpLogin" row>
                        <v-radio
                          color="#077893"
                          :value="true"
                          label="เปิดใช้งาน"
                        ></v-radio>
                        <v-radio
                          color="#077893"
                          :value="false"
                          label="ปิดใช้งาน"
                        ></v-radio>
                      </v-radio-group>
                    </v-flex>
                    <v-flex xs11 sm11 md7 lg7 pa-1>
                      <b>SMTP Username</b>
                      <v-text-field
                        :disabled="SmtpLogin == false"
                        hide-details
                        outlined
                        dense
                        color="#077893"
                        v-model="SmtpUsername"
                        prepend-inner-icon="mdi-account-key-outline"
                        :rules="[(v) => !!v || 'กรุณากรอก SMTP Username']"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs11 sm11 md4 lg4 pa-1>
                      <b>SMTP Password</b>
                      <v-text-field
                        :disabled="SmtpLogin == false"
                        hide-details
                        outlined
                        dense
                        color="#077893"
                        :type="ShowPassword ? 'text' : 'password'"
                        :append-icon="ShowPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="ShowPassword = !ShowPassword"
                        v-model="SmtpPassword"
                        prepend-inner-icon="mdi-lock-outline"
                        :rules="[(v) => !!v || 'กรุณากรอก SMTP Password']"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout
                    row
                    wrap
                    justify-center
                    align-center
                    pt-6
                    pa-1
                    v-if="SelectTypeEmail === true"
                  >
                    <v-flex xs11 sm11 md11 lg11>
                      <b>Transport Layer Security SSL (TLS)</b>
                      <v-radio-group v-model="tls" row>
                        <v-radio
                          color="#077893"
                          :value="true"
                          label="เปิดใช้งาน"
                        ></v-radio>
                        <v-radio
                          color="#077893"
                          :value="false"
                          label="ปิดใช้งาน"
                        ></v-radio>
                      </v-radio-group>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-center align-center pa-1>
                    <v-flex xs11 lg11>
                      <b>ชื่อผู้ส่ง (Sender Display Name)</b>
                      <v-text-field
                        hide-details
                        outlined
                        dense
                        color="#077893"
                        v-model="SenderDisplayName"
                        prepend-inner-icon="mdi-account-outline"
                        :rules="[(v) => !!v || 'กรุณากรอกชื่อผู้ส่ง']"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-center align-center pt-6 pa-1>
                    <v-flex xs11 lg11>
                      <b>อีเมลแอดเดรสผู้ส่ง (Sender Email Address)</b>
                      <v-text-field
                        hide-details
                        outlined
                        dense
                        color="#077893"
                        v-model="SenderEmailAddress"
                        prepend-inner-icon="mdi-email-outline"
                        :rules="RuleEmailAddress"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-center align-center pt-6 pa-1>
                    <v-flex xs11 lg11>
                      <b>ส่งสำเนาถึง (BCC Email Address)</b>
                      <v-text-field
                        hide-details
                        outlined
                        dense
                        color="#077893"
                        v-model="BccEmailAddress"
                        :error-messages="ErrorMessageMail"
                        @input="Fn_CheckRegex()"
                        prepend-inner-icon="mdi-email-multiple-outline"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs11 sm11 md11 lg11 pt-4>
                      <b class="red--text"
                        >หมายเหตุ: สามารถใช้เครื่องหมาย , (จุลภาค)
                        หากต้องการส่งมากกว่า 1 อีเมล</b
                      >
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-actions>
                  <v-layout row wrap justify-center align-center pb-5>
                    <v-flex xs10 md3 lg3>
                      <v-btn
                        block
                        dark
                        color="#077893"
                        :loading="LoadingSave"
                        @click="Fn_CreatePolicy"
                        >{{ $t("policyForm.save") }}</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import { mapGetters } from "vuex";

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: {},
  data: function () {
    return {
      valid: true,
      SelectTypeEmail: false,
      LoadingSave: false,
      ItemPolicy: [],
      SmtpHost: "",
      SmtpPort: "",
      rulesObject: {
        numRegex: "this.value = this.value.replace(/[^0-9]|/g, '').substr(0,4)",
      },
      RuleEmailAddress: [
        (v) => !!v || "กรุณากรอกอีเมลแอดเดรสผู้ส่ง",
        (v) => /.+@.+\..+/.test(v) || "รูปแบบอีเมลไม่ถูกต้อง",
      ],
      HostRules: [
        (v) => !!v || "กรุณากรอก SMTP Host",
        (v) => /.+.+\..+/.test(v) || this.$i18n.t("smtpemailadd.text1"),
      ],
      SmtpUsername: "",
      SmtpPassword: "",
      tls: true,
      SmtpLogin: false,
      ShowPassword: false,
      SenderDisplayName: "",
      SenderEmailAddress: "",
      SenderDisplayNameFalse: "Consent Management Platform",
      SenderEmailAddressFalse: "no-reply-cmp@cmp.inet.co.th",
      BccEmailAddress: "",
      ErrorMessageMail: "",
    };
  },
  computed: {
    ...mapGetters(["Business"]),
    _BusinessName: {
      get() {
        return this.Business.BusinessNameTH || "-";
      },
    },
  },
  mounted() {
    if (this.SelectTypeEmail == false) {
      this.SenderDisplayName = "Consent Management Platform";
      this.SenderEmailAddress = "no-reply-cmp@cmp.inet.co.th";
    } else {
      this.SenderDisplayName = "";
      this.SenderEmailAddress = "";
    }
  },
  methods: {
    async Fn_CreatePolicy() {

      if (this.SmtpLogin == false && this.valid == false) {
        this.valid = true;
      }
      // if (this.$refs.formSMTP.validate()) {
      if (this.valid == true) {
        this.LoadingSave = true;
        var payload = {
          BusinessId: this.$cookies.get("BusinessId"),
          AccountId: this.$cookies.get("OneAccountId"),
          SmtpHost: this.SmtpHost,
          SmtpPort: this.SmtpPort,
          SmtpUsername: this.SmtpUsername,
          SmtpPassword: this.SmtpPassword,
          SenderDisplayName: this.SenderDisplayName,
          SenderEmailAddress: this.SenderEmailAddress,
          BccEmailAddress:
            this.BccEmailAddress === "" ? "" : this.BccEmailAddress.join(","),
          CustomSmtp: this.SelectTypeEmail,
          TLS: this.tls,
          SmtpLogin: this.SmtpLogin,
        };

        var Headers = {
          AccountId: this.$cookies.get("OneAccountId"),
        };
        var dataEncode = await authorization.encodeDataNew(payload);
        var auth = await authorization.encodeDataNew(Headers);
        var headers = { Authorization: "Bearer " + auth };
        this.axios
          .post(
            process.env.VUE_APP_API_FACTORING_SERVICE +
              "config-notify/InsertDetailConfigEmail",
            { Data: dataEncode },
            { headers }
          )
          .then((response) => {
            this.LoadingSave = false;

            if (response.data.Status === "OK") {
              this.ItemPolicy = response.data.Message;
              Toast.fire({
                icon: "success",
                title: response.data.Message,
              });
              this.$router.push("/email-smtp-index");
            } else {
              Toast.fire({
                icon: "error",
                title: response.data.ErrorMessage,
              });
            }
          })
          .catch((error) => {
            this.LoadingSave = false;
            if (error.response) {
              Toast.fire({
                icon: "error",
                title: error.response.data.ErrorMessage,
              });
            } else if (error.request) {
              Toast.fire({
                icon: "error",
                title: error.request,
              });
            } else {
              Toast.fire({
                icon: "error",
                title: error.message || error,
              });
            }
          });
      }
    },
    Fn_BackIndex() {
      this.$router.push("/email-smtp-index");
    },
    Fn_CheckRegex() {
      if (this.BccEmailAddress != "" && this.BccEmailAddress !== undefined) {
        var mail = this.BccEmailAddress.split(",");
        for (var i of mail) {
          const re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
          var check = re.test(String(i).toLowerCase());
          if (check === false) {
            this.ErrorMessageMail = "รูปแบบอีเมลไม่ถูกต้อง";
          } else {
            this.ErrorMessageMail = "";
          }
        }
        this.BccEmailAddress = mail;
      } else {
        this.BccEmailAddress = [];
      }
    },
  },
  watch: {
    SelectTypeEmail(newVal) {
      if (!newVal) {
        this.SenderDisplayName = "Consent Management Platform";
        this.SenderEmailAddress = "no-reply-cmp@cmp.inet.co.th";
      } else {
        this.SenderDisplayName = "";
        this.SenderEmailAddress = "";
      }
    },
  },
};
</script>

<style>
td {
  border-style: hidden !important;
}
</style>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}
</style>
